<div class="technical-resources hidden">
  <h2 class="ui-heading-2-bold technical-resources-title">
    {{ knowledgeSection() }}
  </h2>

  <ul class="technical-resources-content">
    @for(t of technicalResources(); track $index) {
      @if(t.published === true) {
      <li class="technical-resource-item">
        <a rds-link standalone href="{{ t.url }}" target="_blank">
          {{ t.title }}
          <rds-icon namespace="filled" icon="arrow_right" />
        </a>
      </li>
      }
    }
  </ul>
</div>
